import { CommonModule } from '@angular/common';
import { Component, signal, WritableSignal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators,ValidatorFn, ValidationErrors, AbstractControl, } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { AuthService } from '@app/auth.service';
import { DialogMessageComponent } from '@app/dashboard/dialog-message/dialog-message.component';
import { TAny } from '@app/lib/models/common.type';
import { IResponse } from '@app/lib/models/response.model';
import { DialogService } from '@app/lib/services/dialog.service';
import { VersionService } from '@app/version/version';


@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [
    CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        ReactiveFormsModule,
        MatIconModule,
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
   public toggleShowoldPwd: WritableSignal<boolean> = signal(false);
   public toggleShowNewPwd: WritableSignal<boolean> = signal(false);
   public toggleShowConfirmPwd: WritableSignal<boolean> = signal(false);
    version: string | null = null;
    buildTime: string | null = null;
    formattedBuildTime: string = '';
  
    constructor(
      private dialog: MatDialog,
      private authService: AuthService,
      private dialogService: DialogService,
      private router: Router,
      private versionService: VersionService // Inject the service here
    ) { }
  
    resetForm: FormGroup = new FormGroup({
      oldPassword: new FormControl('', Validators.required),
      newPassword: new FormControl('', Validators.required),
      confirmPassword: new FormControl('', Validators.required)
    }, { validators: this.passwordValidator() });


    private passwordValidator(): ValidatorFn {
      return (group: AbstractControl): ValidationErrors | null => {
        const formGroup = group as FormGroup;
        const oldPwd = formGroup.get('oldPassword')?.value;
        const newPwd = formGroup.get('newPassword')?.value;
        const confirmPwd = formGroup.get('confirmPassword')?.value;
    
        const errors: any = {};
    
        if (oldPwd && newPwd && oldPwd === newPwd) {
          errors.sameOldNew = true;
        }
    
        if (newPwd && confirmPwd && newPwd !== confirmPwd) {
          errors.passwordMismatch = true;
        }
    
        return Object.keys(errors).length > 0 ? errors : null;
      };
    }
    
  
    ngOnInit(): void {
  
    }
  
    formatBuildTime(): void {
      if (this.buildTime) {
        const date = new Date(this.buildTime);
        this.formattedBuildTime = date.toLocaleString(); // Customize this format as needed
      }
    }
  
    public togglePwd(section: string): void {
      switch (section) {
        case 'old':
          this.toggleShowoldPwd.update((val: boolean) => !val);
          break;
        case 'new':
          this.toggleShowNewPwd.update((val: boolean) => !val);
          break;
        case 'confirm':
            this.toggleShowConfirmPwd.update((val: boolean) => !val);
            break;
        default:
          console.warn('Unknown section:', section);
          break;
      }
    }
    onReset(): void {
      this.resetForm.reset();
    }
  
    onSubmit(): void {
      if (this.resetForm.invalid) {
        this.resetForm.markAllAsTouched();
    
        const errors = this.resetForm.errors;
    
        if (errors && errors['sameOldNew']) {

          this.dialogService.openDialog1( {
            data: {
              title: 'Validation Error',
              message: 'Old password and new password cannot be the same.',
              icon: 'error'
            }, disableClose: true,           // Prevents closing on outside click or ESC
  hasBackdrop: true,            // Shows backdrop to block interaction
  backdropClass: 'dialog-backdrop', // Optional: custom styling
          });
          return;
        }
    
        if (errors && errors['passwordMismatch']) {

          this.dialogService.openDialog1( {
            data: {
              title: 'Validation Error',
              message: 'New password and confirm password do not match.',
              icon: 'error'
            }, disableClose: true,           // Prevents closing on outside click or ESC
  hasBackdrop: true,            // Shows backdrop to block interaction
  backdropClass: 'dialog-backdrop', // Optional: custom styling
          });
          return;
        }
    
        // For required field errors (username/password missing)
        if (
          this.resetForm.get('oldPassword')?.hasError('required') ||
          this.resetForm.get('newPassword')?.hasError('required') ||
          this.resetForm.get('confirmPassword')?.hasError('required')
        ) {
          this.dialogService.openDialog1( {
            data: {
              title: 'Validation Error',
              message: 'All fields are required.',
              icon: 'error'
            }, disableClose: true,           // Prevents closing on outside click or ESC
  hasBackdrop: true,            // Shows backdrop to block interaction
  backdropClass: 'dialog-backdrop', // Optional: custom styling
          });
          return;
        }
    
        return;
      }
      
  const formValues = this.resetForm.value;
  const oldPassword =formValues.oldPassword ;
    const newPassword = formValues.newPassword;
    const confirmedPassword = formValues.confirmPassword;
      
     

       this.authService.changePassword(oldPassword, newPassword, confirmedPassword).subscribe({
            next: (res: TAny) => {
              if(res.success){
                const dialogRef = this.dialogService.openDialog1( {
                  data: {
                    title: 'Success',
                    message: res.success,
                    icon: 'check_small'
                  }, disableClose: true,           // Prevents closing on outside click or ESC
  hasBackdrop: true,            // Shows backdrop to block interaction
  backdropClass: 'dialog-backdrop', // Optional: custom styling
                });
              
                dialogRef.afterClosed().subscribe(() => {
                  this.authService.logout()
                  // 👇 Replace '/target-route' with your actual route
                  this.router.navigate(['/login']);
                });
              }else if(res.failure){
                this.dialogService.openDialog1( {
                  data: {
                    title: 'Error',
                    message:res.failure,
                    icon:'error', // ✅ Default icon if not provided
                  }, disableClose: true,           // Prevents closing on outside click or ESC
  hasBackdrop: true,            // Shows backdrop to block interaction
  backdropClass: 'dialog-backdrop', // Optional: custom styling
                });

              }
            },
            error: (err) => {
              console.error('Error changing password:', err);
      this.dialogService.openDialog1( {
        data: {
          title: 'Error',
          message: 'Something went wrong while changing the password.',
          icon: 'error'
        }, disableClose: true,           // Prevents closing on outside click or ESC
  hasBackdrop: true,            // Shows backdrop to block interaction
  backdropClass: 'dialog-backdrop', // Optional: custom styling
      });
            }
          });

}}
